// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3092B","title":"InfoRow_title__3u1Tx"};